import React, { useState } from "react";
import { useNavigate, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { logout } from '../../redux/actions/authActions';

export default function SHGRanking() {
  const authState = useSelector(state => state.authReducer);
  const { isLoggedIn } = authState;
  const [userName] = useState(authState.user.name);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const taiRankings = [
    { name: "सुनीता गावंडे", place: "नागपूर (Urban)" },
    { name: "मीनाक्षी पाटील", place: "कोल्हापूर (Rural)" },
    { name: "संध्या पवार", place: "पुणे (Urban)" },
    { name: "रेखा जाधव", place: "औरंगाबाद (Rural)" },
    { name: "आशा भोसले", place: "नाशिक (Urban)" },
    { name: "शालिनी शिंदे", place: "सांगली (Rural)" },
    { name: "कविता कदम", place: "ठाणे (Urban)" },
    { name: "लता मोरे", place: "अमरावती (Rural)" },
    { name: "वंदना देशमुख", place: "सोलापूर (Urban)" },
    { name: "प्रेमिला पाटील", place: "रत्नागिरी (Rural)" },
  ];

  const gatRankings = [
    { name: "प्रगती महिला बचत गट", place: "सांगली (Rural)" },
    { name: "शक्ती महिला संघ", place: "पुणे (Urban)" },
    { name: "उमेद महिला गट", place: "लातूर (Rural)" },
    { name: "मातोश्री बचत गट", place: "औरंगाबाद (Urban)" },
    { name: "सावित्री महिला मंडळ", place: "कोल्हापूर (Rural)" },
    { name: "सहयोग महिला संस्था", place: "नाशिक (Urban)" },
    { name: "गौरव बचत गट", place: "रत्नागिरी (Rural)" },
    { name: "मंगल महिला प्रतिष्ठान", place: "ठाणे (Urban)" },
    { name: "संघर्ष महिला गट", place: "अमरावती (Rural)" },
    { name: "संकल्प बचत गट", place: "नागपूर (Urban)" },
  ];

  const today = new Date().toLocaleDateString('en-IN', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });

  return (
    <div className="flex flex-col min-h-screen font-sans text-white bg-black">
      <header className="flex flex-row justify-between px-4 py-1 bg-black shadow-md sticky top-0 z-50 border-b border-green-500">
        <div className="flex flex-col justify-start">
          <h1 className="text-sm lg:text-lg font-bold text-yellow-200">
            🌸 Think5Whys Maha SAKSHAM ताई & Gaurav Gat Rankings
          </h1>
          <p className="text-xs lg:text-m text-gray-300 mt-2">
            महाराष्ट्रातील महिलांच्या डिजिटल आणि बचत सक्षमीकरणासाठी साप्ताहिक क्रमवारी
          </p>
        </div>

        <div className="flex flex-col items-center justify-center gap-2">
          {isLoggedIn && (
            <div className="hidden md:flex flex-col items-center justify-center gap-1">
              <span className="text-white text-xs lg:text-sm text-center">{userName}</span>

              <button
                onClick={handleLogout}
                className="w-8 h-8 flex items-center justify-center text-lg bg-green-500 text-white rounded-full hover:bg-green-600 transition"
                title="Logout"
              >
                ⏻
              </button>
            </div>
          )}
          <button
            onClick={() => setIsMobileMenuOpen(s => !s)}
            className="md:hidden w-8 h-8 flex items-center justify-center text-xl bg-green-700 text-white rounded-md hover:bg-green-800 transition"
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? "×" : "☰"}
          </button>
        </div>
      </header>

      {/* MOBILE MENU */}
      {isMobileMenuOpen && (
        <nav className="md:hidden bg-black text-white border border-green-400 flex flex-col px-4 py-3 space-y-3">
          {isLoggedIn && (
            <div className="border-t pt-3 border-green-500 text-white">
              <p className="mb-2 text-xs lg:text-sm">{userName}</p>
              <button
                onClick={handleLogout}
                className="bg-green-500 text-white mt-4 px-4 py-2 rounded text-sm hover:bg-green-600 w-full transition"
              >
                Logout
              </button>
            </div>
          )}
        </nav>
      )}

      <section className="w-full mt-2">
        <h2 className="text-sm lg:text-lg font-semibold text-pink-400 mb-2 text-center">
          🏅 Digital SAKSHAM ताई Rankings (Individual) today : {today} 
        </h2>

        <div className="grid grid-cols-2 lg:grid-cols-5 gap-1">
          {taiRankings.map((tai, index) => (
            <div
              key={index}
              className="bg-emerald-800/60 rounded-xl shadow-md border border-emerald-700 p-4 text-center hover:bg-emerald-700/70 transition-all"
            >
              <div className="text-sm font-bold text-yellow-200">#{index + 1}</div>
              <div className="text-sm font-semibold mt-1">{tai.name}</div>
              <div className="text-xs text-gray-300">{tai.place}</div>
            </div>
          ))}
        </div>
      </section>

      <div className="w-full border-t border-emerald-700 my-2 opacity-70"></div>

      <section className="w-full mb-2">
        <h2 className="text-sm lg:text-lg font-semibold text-emerald-300 mb-3 text-center">
          🏆 Digital Gaurav Gat Rankings (Group) today : {today} for 
        </h2>

        <div className="grid grid-cols-2 lg:grid-cols-5 gap-1">
          {gatRankings.map((gat, index) => (
            <div
              key={index}
              className="bg-teal-800/60 rounded-xl shadow-md border border-teal-700 p-4 text-center hover:bg-teal-700/70 transition-all"
            >
              <div className="text-sm font-bold text-yellow-300">#{index + 1}</div>
              <div className="text-sm font-semibold mt-1">{gat.name}</div>
              <div className="text-xs text-gray-300">{gat.place}</div>
            </div>
          ))}
        </div>
      </section>

      <footer className="bg-black border-t border-pink-300 text-white py-2 px-4 mt-2">
        <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left space-y-4 md:space-y-0">
          <p className="text-xs sm:text-sm">&copy; 2025 Think5Whys Global DeepTech Solutions.</p>
          <div className="flex flex-row gap-2 sm:gap-6 text-xs sm:text-sm">
            <Link to="/about-us" className="text-white hover:text-pink-200 transition">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-pink-200 transition">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-pink-200 transition">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-pink-200 transition">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
